import { render, staticRenderFns } from "./VaccineInputForm.vue?vue&type=template&id=63bf22cc&scoped=true&"
import script from "./VaccineInputForm.vue?vue&type=script&lang=js&"
export * from "./VaccineInputForm.vue?vue&type=script&lang=js&"
import style0 from "./VaccineInputForm.vue?vue&type=style&index=0&id=63bf22cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf22cc",
  null
  
)

export default component.exports